import React, { type FC, type ReactNode } from 'react';
import classnames from 'classnames';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import styles from 'theme/pages/wise/WiseProduct/components/WiseAccordion/WiseAccordion.module.scss';

export type WiseAccordionProps = {
  sectionId: string;
  title: ReactNode;
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  children: ReactNode;
  className?: string;
};

const WiseAccordion: FC<WiseAccordionProps> = ({
  sectionId,
  title,
  expanded,
  onExpandedChange,
  children,
  className
}) => (
  <Accordion
    className={classnames(
      styles.root,
      className,
      'StylePath-Pages-Wise-WiseProduct-components-WiseAccordion'
    )}
    expanded={expanded}
    elevation={0}
    disableGutters
    onChange={(_, isExpanded) => onExpandedChange(isExpanded)}
    TransitionProps={{ unmountOnExit: true }}>
    <AccordionSummary
      className={styles.summary}
      expandIcon={<ExpandMoreIcon className={styles.expandIcon} fontSize="small" />}
      aria-controls={`wise-accordion-${sectionId}-content`}
      id={`wise-accordion-${sectionId}-header`}>
      <span className={styles.titleWrap}>
        <span className={styles.title}>{title}</span>
      </span>
    </AccordionSummary>
    <AccordionDetails className={styles.details}>
      <div className={styles.detailsInner}>{children}</div>
    </AccordionDetails>
  </Accordion>
);

export default WiseAccordion;
